module.exports = {"220521100":"快大茂镇","220521101":"二密镇","220521102":"果松镇","220521103":"石湖镇","220521104":"大安镇","220521105":"光华镇","220521106":"兴林镇","220521107":"英额布镇","220521108":"三棵榆树镇","220521109":"西江镇","220521120":"通化聚鑫经济开发区管理委员会（特殊乡镇）","220521200":"富江乡","220521201":"四棚乡","220521202":"东来乡","220521203":"大泉源满族朝鲜族乡","220521204":"金斗朝鲜族满族乡","220521401":"东宝新村"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220521.json
// module id = 641
// module chunks = 0